import { IP_CIDR_PATTERN } from '../../constants';

const ipToInt = (ip: string): number => {
  return ip.split('.').reduce((acc, octet) => ((acc << 8) + Number(octet)) >>> 0, 0);
};

/**
 * IPv4 CIDR 문자열의 유효성을 검증합니다.
 * ex message: 올바른 CIDR 블록 단위를 입력해 주세요. (common.validation.cidr.enter_valid_cidr)
 * @description
 * - IPv4/CIDR 형식(`x.x.x.x/n`)인지 검사합니다.
 * - CIDR 마스크 범위(0~32)인지 검사합니다.
 * - 입력 IP가 CIDR의 네트워크 주소인지 검사합니다.
 * @example
 * checkValidCidr('10.0.0.0/24') // true
 * checkValidCidr('10.0.0.1/24') // false
 */
const checkValidCidr = (ipCidr: string): boolean => {
  if (!IP_CIDR_PATTERN.test(ipCidr)) {
    return false;
  }

  const [ip, maskString] = ipCidr.split('/');
  const mask = Number(maskString);

  if (Number.isNaN(mask) || mask < 0 || mask > 32) {
    return false;
  }

  const ipInt = ipToInt(ip);

  if (mask === 32) {
    return true;
  }

  if (mask === 0) {
    return ipInt === 0;
  }

  const networkInt = ((ipInt >>> (32 - mask)) << (32 - mask)) >>> 0;

  return ipInt === networkInt;
};

export { checkValidCidr };
